<template>
    <div>
        <LaNavigationBar />
        <div class="container-content container-indentation">
            <router-view />
        </div>
        <LaFooter />
    </div>
</template>

<script>
import LaNavigationBar from "@/components/layout/NavigationBar";
import LaFooter from "@/components/layout/Footer";
import store from "@/store/store";
import { actionTypes as publisherActionTypes } from "@/store/Publisher/types";

export default {
    name: "LaMenuView",
    components: {
        LaNavigationBar,
        LaFooter,
    },
    setup() {
        // Restore publisher/mode/period from localStorage on every logged-in page load.
        // Without this, a hard refresh on routes that aren't a dashboard (e.g. /fees,
        // /ads-txt, /websites) falls back to default state (ltba mode, empty selections)
        // and the navbar loses its picker + menu.
        store.dispatch(publisherActionTypes.restoreFromLS);
    },
};
</script>

<style lang="scss" scoped></style>
